// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {updateTransfer} from '../../shared/repositories';

export const updateTransferStatus = transfer =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await updateTransfer(transfer);

            dispatch({
                data: transfer,
                type: actions.UPDATE_TRANSFER_STATUS_SUCCESS
            });

            successAlertBar('TRANSFER_UPDATED_SUCCESSFULLY');

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/transfers/action-creators/status.js